<template>
<v-card class="elevation-12">
    <v-toolbar flat>
    <v-toolbar-title class="layout row justify-center">
        {{redirect ? $t('login.titleRedirect') : $t('login.title')}}
    </v-toolbar-title>
    </v-toolbar>
    <v-form @submit.prevent="onSubmit($event)">
        <v-card-text>
            <v-layout column>
                <v-layout justify-center>
                    <v-flex xs6>
                        <v-img :src="require('../assets/SpLogo.png')"></v-img>
                    </v-flex>
                </v-layout>
                <v-flex class="text-xs-center">
                    <span v-if="error" class="error--text">{{error}}</span>
                </v-flex>
                <v-layout row justify-center v-if="!redirect">
                    <v-flex xs12 sm10 md8>
                        <v-text-field  
                        label="E-mail" type="email"
                        v-model="form.email"
                        required data-vv-name="email"
                        v-validate="'required|email'"
                        :error-messages="errors.collect('email')"
                        ></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout row justify-center v-if="!redirect">
                    <v-flex xs12 sm10 md8>
                        <v-text-field id="password" 
                        :label="$t('login.password')" v-model="form.password" 
                        type="password" required v-validate="'required'"
                        data-vv-name="password"
                        :error-messages="errors.collect('password')"
                        ></v-text-field>
                    </v-flex>
                </v-layout>
            </v-layout>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="$router.push({name:'Register'})" flat v-if="!redirect">
                {{$t('login.register')}}
            </v-btn>
            <v-btn color="success" type="submit" :loading="loading" :disabled="loading">
                {{ redirect ? $t('login.actionRedirect') : $t('login.action')}}
            </v-btn>
            <v-spacer></v-spacer>
            <!-- <v-flex><v-btn flat block large @click="resetPassword">{{$t('login.forgotPassword')}}</v-btn></v-flex> -->
        </v-card-actions>
    </v-form>
</v-card>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
    $_veeValidate: {
        validator: 'new'
    },
    data: () => {
    return {
      valid: true,
      form:{
          email: '',
          password: ''
      },
      error: null,
      loading: false,
      redirect: false
    }
    },
    computed:{
    ...mapGetters([
        'authError',
        'user'
    ])
    },
    mounted() {
        this.autoLogin()
    },
    methods:{
        clear(){
            this.form.email = ''
            this.error = null
            this.form.password = ''
            this.$validator.reset()
        },
        async onSubmit(event){
            try {
                this.loading = true
                let valid = await this.$validator.validateAll()
                if(valid){
                    let res = await this.$store.dispatch('doLogin', this.form)
                    if(!res.ok){
                        this.error = res.error
                    }else{
                        this.error = null
                        this.$router.push({name:'AllProducts'})
                    }
                }
            } catch (err) {
                if(err.response && err.response.data.error)
                    this.error = err.response.data.error
                else
                this.error = "Algo de errado ocorreu. Tente novamente em instantes."
            } finally {
                this.loading = false
            }
        }, 
        async autoLogin() {
            try {
                this.redirect = this.$route.query.u && this.$route.query.p
                if (this.redirect) {
                    this.loading = true
                    const email =  decodeURI(this.$route.query.u)
                    const password =  this.$route.query.p
                    const res = await this.$store.dispatch('doLogin', { email: email, password: password, enc: true })
                    this.loading = false
                    if(!res.ok){
                        this.error = res.error
                    } else {
                        this.error = null
                        this.$router.push({ name:'AllProducts' })
                    }
                }
            } catch (err) {
                console.log('err:', err)
            } finally {
                this.loading = false
            }
        }
    }
}
</script>

<style>

</style>
